import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const createAiReviewJob = (payload = {}) => Http.post('/ai-review-jobs', payload)

export const getAiReviewJob = uuid => Http.get(`/ai-review-jobs/${uuid}`)

export const getAiReviewJobs = (params = {}) => Http.get(`/ai-review-jobs${serialize(params)}`)

export const getReviewRequestsForAi = (params = {}) => Http.get(`/review-requests${serialize(params)}`)
